// extracted by mini-css-extract-plugin
export default {"portfolio":"PortfolioPage_portfolio__yYW-H","flex":"PortfolioPage_flex__LLyHx","imgPort":"PortfolioPage_imgPort__pFYCr","overlay":"PortfolioPage_overlay__TG4N7"};